import axios from 'axios';

const BASE_URL_UNPAID_INVOICE_TRIGGER = '/app/unpaidInvoiceTrigger';

export const createOrUpdateUnpaidInvoiceConfig = async (oracleId, daysAfterDueDate) => {
    const payload = {
        oracleId,
        daysAfterDueDate,
    };

    const { data } = await axios.post(`${BASE_URL_UNPAID_INVOICE_TRIGGER}`, payload, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
    });

    return data;
};

export const getUnpaidInvoiceConfig = async (oracleId) => {
    const { data } = await axios.get(`${BASE_URL_UNPAID_INVOICE_TRIGGER}/${oracleId}`, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
    });

    return data;
};
